var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"4"}},[_c('ResetPasswordCard',{attrs:{"title":"Reset password","buttonText":"Reset","email":this.email,"token":this.token}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }